import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/Auth";
import { errorText } from "@/lib/api";

export const AuthCallback = () => {
  const { hash } = useLocation();
  const navigate = useNavigate();
  const { loginWithGoogle, setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    loginWithGoogle(sessionId)
      .then(() => navigate("/admin", { replace: true }))
      .catch((e) => {
        setUser(false);
        navigate("/admin/login", { replace: true, state: { error: errorText(e, "No se pudo entrar con Google") } });
      });
  }, [hash, loginWithGoogle, navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center" data-testid="auth-callback">
      <Loader2 className="w-6 h-6 animate-spin text-granate" />
    </div>
  );
};
